import store from '@/store'
import ClockInRouter from '@/components/pages/clockIn/index.vue';
import ClockIns from '@/components/pages/clockIn/ClockIns.vue';
import ClockInDetail from '@/components/pages/clockIn/ClockInDetail.vue';
import StampingQr from '@/components/pages/clockIn/StampingQr.vue';

export default {
  path: '/clockIn',
  name: 'ClockInRouter',
  component: ClockInRouter,
  children: [
    {
      path: '/clockIns/:date',
      component: ClockIns,
      name: 'ClockIns',
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/:tutorId/clockIns/:date',
      component: ClockInDetail,
      name: 'ClockInDetail',
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
      beforeEnter: ((to, from, next) => {
        if (store.state.auth?.profile?.authority !== 'tutor') {
          // 権限がtutor以外の場合OK
          next()
        } else if (to?.params?.tutorId === store.state.auth?.profile?.id) {
          // 権限がtutorかつ自身の勤怠の場合はOK
          next()
        } else {
          next({ name: 'Home' })
        }
      }),
    },
    {
      path: '/stampingQr',
      component: StampingQr,
      name: 'StampingQr',
      meta: {
        acceptRoles: ['tutor'],
      },
    },
  ],
}
